'use strict';

var React = require('react');
var Classnames = require('classnames');
var _ = require('lodash');
var TextInput = require('../Common/TextInput.jsx');
var RadioInput = require('../Common/RadioInput.jsx');
var CancelDoneButtons = require('../Common/CancelDoneButtons.jsx');
var InlineMessage = require('../Common/InlineMessage.jsx');
var InlineInfoButton = require('../Common/InlineInfoButton.jsx');
var InlineInfoMessage = require('../Common/InlineInfoMessage.jsx');
var SelectInput = require('../Common/SelectInput.jsx');
//constants
var Constants = require('../../constants/FundingYourProductConstants.js');
var FundingYourProductActions = require('../../actions/FundingYourProductActions.js');

var list;

var filterOptionsHandler = function (options, filterString) {
    try {

        if (Object.prototype.toString.call(options) !== '[object Array]' && typeof filterString !== 'string') {
            throw 'param options/filterString is invalid.';
        }
        if (filterString != '') {
            options = list;
            filterString = filterString.toLowerCase();
            options = options.filter(function (o) {
                return o.productName.toLowerCase().indexOf(filterString) > -1 ||
                o.abn.indexOf(filterString) > -1 ||
                o.usi.toLowerCase().indexOf(filterString) > -1;
            });
        }
    }
    catch (err) {
        console.log(err);
    }
    options = _.take(options, 5);

    if (options.length === 0) {
        return [
            { value: ' ', label: 'No results found', productName: '', usi: '', abn: '', isActive: '' }
        ];
    }
    return options;
}

var ExternalRollover = React.createClass({
    getInitialState: function () {
        return {
            hideHelpText: true,
            externalProviderFound: true
        };
    },

    getDefaultProps: function () {
        return {
            inSummary: false
        }
    },

    selectRollOverType: function (event) {
        this.updateStoreModel(event);
        this.setState({ hideExternalAmount: event.target.value === Constants.HowMuchToRollOver.ENTIRE_BALANCE });
    },

    updateStoreModelPredictive: function (event) {
        if (event.target.value !== ' ') {
            var tempListSelected = this.getDetailsbyId(event.target.value);
            FundingYourProductActions.updateExternalPredictiveDetails({
                usi: tempListSelected.usi,
                predictiveName: tempListSelected.productName,
                isExternalProviderManualEntry: false,
                index: this.props.index
            });
            this.setState({ externalProviderFound: true });
        }
        else {
            FundingYourProductActions.updateExternalPredictiveDetails({
                usi: '',
                predictiveName: '',
                isExternalProviderManualEntry: false,
                index: this.props.index
            });
            this.setState({ externalProviderFound: false });
        }
    },

    updateStoreModel: function (event) {
        var fieldId = event.target.model;
        var fieldValue = event.target.value;
        this.updateRollover(fieldId, fieldValue);
    },

    getDetailsbyId: function (id) {
        var tempList = this.props.usiList;
        tempList = tempList.filter(function (o) {
            return o.productName === id || o.value === id || o.label === id
        });
        if (tempList.length > 0) {
            return tempList[0];
        }
        return '';
    },

    updateRollover: function (fieldId, fieldValue) {
        if (this.props.inSummary) {
            FundingYourProductActions.updateExistingRollover(fieldId, fieldValue, Constants.RollOverTypes.EXTERNAL, this.props.index);
        } else {
            FundingYourProductActions.updateNewRollover(fieldId, fieldValue, Constants.RollOverTypes.EXTERNAL);
        }
    },

    cancelExternalRollover: function (event) {
        this.setState({ externalProviderFound: true });
        if (this.props.onCancelClick) {
            this.props.onCancelClick(event);
        } else {
            FundingYourProductActions.setActiveFundType('');
            FundingYourProductActions.toggleFundingTypeVisibility();
            this.setState({ hideExternalAmount: true });
        }
    },

    submitExternalRollover: function (event) {
        if (this.props.onDoneClick) {
            this.props.onDoneClick(event);
        } else {
            FundingYourProductActions.submitNewExternalRollover();
            if (this.props.data.errorList.length === 0) {
                this.setState({ hideExternalAmount: true });
            }
        }
    },

    toggleShowHideHelpText: function () {
        this.setState({
            hideHelpText: !this.state.hideHelpText
        });
    },

    handlefilterOptions: function (options, filterString) {
        return filterOptionsHandler(options, filterString);
    },

    handleClickHere: function () {
        this.updateRollover(Constants.externalProviderManualEntry, true);
        this.updateRollover(Constants.externalProviderPredictiveSearch, false);
        this.setState({ externalProviderFound: true });
    },

    render: function () {
        var maxRolloverError = null;
        var isNumberOfRolloversValid = _.filter(this.props.data.errorList, { id: 'fypMaxRolloversError' });
        if (isNumberOfRolloversValid.length > 0 && isNumberOfRolloversValid[0]) {
            maxRolloverError =
                <InlineMessage id="fypMaxFundingSourcesError"
                               isHidden={!isNumberOfRolloversValid[0].message}
                               type={isNumberOfRolloversValid[0].type}
                               message={isNumberOfRolloversValid[0].message} />;
        }
        var option = [];
        list = this.props.usiList;
        var hideSpinner = this.props.usiList && this.props.usiList.length > 0;
        var hideHelpText = this.state.hideHelpText;
        var filterOptions = this.handlefilterOptions;
        var predictiveSearchError = _.filter(this.props.data.errorList, { id: 'fypExternalRolloverProvider2' });
        var hideExternalProviderError = this.state.externalProviderFound || predictiveSearchError.length > 0;
        var handleClickHere = this.handleClickHere;
        var fundingContent = this.props.content.fundingYourProduct;
        var externalRollOverProvider = '';
        if (this.props.data.isExternalProviderManualEntry) {
            externalRollOverProvider =
            (<div>
                <TextInput id="fypExternalRolloverProvider"
                           label="External rollover provider"
                           customClass="external-rollover-field"
                           className={Classnames({ 'external-rollover-edit-mode': this.props.inSummary })}
                           value={this.props.data.rollOverName}
                           model="rollOverName"
                           symbol="none"
                           onBlur={this.updateStoreModel}
                           errorList={this.props.data.errorList} />
                <TextInput id="fypExternalRollOverUsi"
                           value={this.props.data.usi}
                           label="Unique Superannuation Identifier (USI)"
                           model="usi"
                           symbol="none"
                           mandatory={false}
                           customClass="external-rollover-field"
                           className={Classnames({ 'external-rollover-edit-mode': this.props.inSummary })}
                           helpText={fundingContent.usiHelp}
                           onBlur={this.updateStoreModel}
                           errorList={this.props.data.errorList} />
            </div>)
        } else {
            externalRollOverProvider =
            (<div>
                <SelectInput label="External rollover provider"
                             id="fypExternalRolloverProvider2"
                             model="rollOverNamePredictive"
                             placeholder="Search by fund name, USI or ABN"
                             searchable={true}
                             clearable={true}
                             hideSpinner={hideSpinner}
                             className="remove-select-clear remove-select-arrow"
                             backspaceRemoves={true}
                             options={option}
                             value={this.props.data.rollOverNamePredictive}
                             onChange={this.updateStoreModelPredictive}
                             filterOptions={filterOptions}
                             noRequiredValidation={true}
                             errorList={this.props.data.errorList} />
                <InlineMessage id="fypExternalProviderError"
                               type="info"
                               errorClickHandler={handleClickHere}
                               isHidden={hideExternalProviderError}
                               message={fundingContent.externalProviderNotFoundError} />
                {(this.props.data.rollOverNamePredictive === '') ? null : 
                (<div className="form-section">
                        <div className="form-label-section">
                            <label>Unique Superannuation Identifier (USI)</label>
                            <InlineInfoButton helpText={fundingContent.usiHelp}
                                              isHidden={hideHelpText}
                                              toggleShowHideHelpText={this.toggleShowHideHelpText} />
                            <InlineInfoMessage isHidden={hideHelpText}
                                        message={fundingContent.usiHelp} /><br />
                            <label>{this.props.data.usi}</label>
                        </div>
                    </div>)}
            </div>)
        }

        return (
            <div id="fundingYourProductExternalRolloverComponent" className="row">
                {this.props.activeFundType === Constants.FundingTypes.External_rollover ?
                <div className="col-md-12 external-rollover-row">
                    {externalRollOverProvider}
                    <TextInput id="fypExternalRolloverAccountNumber"
                               label="Account/policy number"
                               value={this.props.data.accountNumber}
                               customClass="external-rollover-field"
                               className={Classnames({ 'external-rollover-edit-mode': this.props.inSummary })}
                               model="accountNumber"
                               symbol="none"
                               mandatory={false}
                               onBlur={this.updateStoreModel}
                               errorList={this.props.data.errorList} />
                    <TextInput id="fypExternalRolloverRemainingBalance"
                               label="Approximate total balance"
                               symbol="currency"
                               model="remainingBalance"
                               value={this.props.data.remainingBalance}
                               customClass="external-rollover-field"
                               className={Classnames({ 'external-rollover-edit-mode': this.props.inSummary })}
                               onBlur={this.updateStoreModel}
                               errorList={this.props.data.errorList} />
                    <RadioInput id="fypExternalRolloverPartialRolloverType"
                                value={this.props.data.partialRolloverType}
                                data={Constants.ExternalRolloverTypeData}
                                model="partialRolloverType"
                                label="How much would you like to rollover?"
                                customClass="external-rollover-field"
                                className={Classnames({ 'external-rollover-edit-mode': this.props.inSummary })}
                                onChange={this.selectRollOverType}
                                isHidden={this.props.activeFundType !== Constants.FundingTypes.External_rollover}
                                errorList={this.props.data.errorList} />
                    <TextInput id="fypExternalRolloverAmount"
                               isHidden={this.props.data.hideAmount}
                               label="Amount"
                               symbol="currency"
                               model="rollOverAmount"
                               value={this.props.data.rollOverAmount}
                               customClass="external-rollover-field"
                               className={Classnames({ 'external-rollover-edit-mode': this.props.inSummary })}
                               onBlur={this.updateStoreModel}
                               errorList={this.props.data.errorList} />
                    <CancelDoneButtons id="externalRolloverFormButton"
                                       index={this.props.index}
                                       onClickCancel={this.cancelExternalRollover}
                                       onClickDone={this.submitExternalRollover} />
                    {maxRolloverError}
                </div> : null}
            </div>
            )
    }
});

module.exports = ExternalRollover;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/FundingYourProduct/ExternalRollover.jsx